<template>
  <a
    v-if="manager && fullName && manager.slug"
    :href="`${managerFrontUrlAddress}/team/${manager.slug}`"
    target="_blank"
  >
    <feather-icon
      icon="EyeIcon"
      size="18"
      opacity=".6"
      hover-opacity=".9"
      class="hover-scale-up ml-1"
    />
    {{ fullName }}
  </a>
  <a
    v-else-if="manager && !fullName && manager.slug"
    :href="`${managerFrontUrlAddress}/team/${manager.slug}`"
    target="_blank"
  >
    تعریف نشده
    <feather-icon
      icon="EyeIcon"
      size="18"
      opacity=".6"
      hover-opacity=".9"
      class="hover-scale-up mr-1"
    />
  </a>
  <a
    v-else-if="manager && !fullName && !manager.slug"
    :href="`${managerFrontUrlAddress}/team`"
    target="_blank"
  >
    تعریف نشده
    <!-- <feather-icon
          icon="EyeIcon"
          size="18"
          opacity=".6"
          hover-opacity=".9"
          class="hover-scale-up mr-1"
      /> -->
  </a>
</template>

<script>

export default {
  name: 'ManagerCell',
  props: ['manager', 'lang', 'link'],
  computed: {
    managerFrontUrlAddress() {
      return `${process.env.VUE_APP_FRONT_BASE_URL}`
    },
    fullName() {
      if (this.manager) {
        return this.manager.firstName + this.manager.lastName
      }
      return ''
    },
  },
}
</script>
